import React from "react";
import { Box } from "@material-ui/core";
import { useSelector } from "react-redux";
import BarPositiveAndNegative from "components/visuals/BarPositiveAndNegative";

import { selectors } from "modules/customer/insights/portfolio/catchment/demographicBreakdown";

const TenureIndex = () => {
    const tenureIndex = useSelector(state => selectors.tenureIndex(state));
    const { loading, error, categories, values } = tenureIndex;
    
    const options = {
        title: {
            text: "Household tenure"
        },
        xAxis: [
            { categories: categories },
            {}
        ],
        series: [{
            data: values
        }]
    };

    return (
        <Box data-cy="tenure-index">
            <BarPositiveAndNegative loading={loading} error={error} options={options} />
        </Box>
    );
};

export default TenureIndex;
